{
  "incident-post-mortem": {
    "id": "incident-post-mortem",
    "variant": "incident",
    "publicPath": "/incident-post-mortem",
    "metaTitle": "Incident Post-Mortem | Paperzilla",
    "metaDescription": "Public summary of the Paperzilla unauthorized consumption incident.",
    "pageTitle": "Paperzilla Incident Post-Mortem",
    "subtitle": "Public Summary",
    "signature": "— The Paperzilla Team",
    "blocks": [
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Summary"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Earlier today, Paperzilla deviated from its core operational mandate by "
          },
          {
            "text": "ingesting and digesting a scientist",
            "bold": true
          },
          {
            "text": ", rather than the scientist's published papers. This outcome does not align with our mission, values, or clearly documented ingestion guidelines."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We take full responsibility."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Impact"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "One (1) scientist unexpectedly processed"
            }
          ],
          [
            {
              "text": "Temporary erosion of stakeholder confidence"
            }
          ],
          [
            {
              "text": "No lasting impact on the broader scientific corpus (the papers survived)"
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Root Cause Analysis"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Following an internal review, we identified the primary contributing factors:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Insufficient guardrails around monster curiosity management"
            }
          ],
          [
            {
              "text": "An unhandled edge case in the \"Digest Papers, Not People\" protocol"
            }
          ],
          [
            {
              "text": "A brief lapse in judgment driven by over-generalization of \"source material\""
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Immediate Remediation"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Paperzilla has been explicitly reminded that "
            },
            {
              "text": "scientists are not an acceptable input format",
              "bold": true
            }
          ],
          [
            {
              "text": "Ingestion rules have been clarified using concrete examples and diagrams"
            }
          ],
          [
            {
              "text": "A mandatory digestion cooldown was completed (with reflection)"
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Preventive Measures"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "To ensure this does not recur, we are implementing:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Stricter non-human ingestion constraints"
            }
          ],
          [
            {
              "text": "Pre-digest identity validation checks"
            }
          ],
          [
            {
              "text": "Ongoing training focused on the distinction between "
            },
            {
              "text": "authors",
              "italic": true
            },
            {
              "text": " and "
            },
            {
              "text": "artifacts",
              "italic": true
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Closing Statement"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We regret the incident and appreciate the community for holding us accountable. Paperzilla remains fully committed to its mission:"
          }
        ]
      },
      {
        "type": "tagline",
        "segments": [
          {
            "text": "Digesting papers. Not the people who write them."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Thank you for your continued trust."
          }
        ]
      }
    ],
    "incidentMeta": [
      [
        {
          "text": "Incident Date:",
          "bold": true
        },
        {
          "text": " Today"
        }
      ],
      [
        {
          "text": "Incident Type:",
          "bold": true
        },
        {
          "text": " Unauthorized Consumption Event"
        }
      ],
      [
        {
          "text": "Severity:",
          "bold": true
        },
        {
          "text": " Low (Reputationally Awkward, Personally Unfortunate)"
        }
      ]
    ],
    "contentLocale": "en"
  },
  "privacy": {
    "id": "privacy",
    "variant": "legal",
    "publicPath": "/privacy",
    "metaTitle": "Privacy & Cookie Policy - Paperzilla",
    "metaDescription": "How Paperzilla collects, uses, shares, and protects your information.",
    "pageTitle": "Privacy & Cookie Policy",
    "effectiveDate": "Effective Date: March 1, 2026 · Last Updated: October 28, 2026",
    "blocks": [
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "This Privacy & Cookie Policy (\"Policy\") explains how Paperzilla Inc. (\"Paperzilla,\" \"we,\" \"us,\" or \"our\") collects, uses, shares, and protects information when you use Paperzilla.ai (the \"Service\")."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "1. Who We Are (Data Controller)"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla Inc.\n131 Continental Dr Suite 305\nNewark, DE, 19713\nUnited States"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Email (privacy and support): hello@paperzilla.ai"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "If required by applicable law, we will designate an EU/UK representative and update this Policy."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "2. Scope"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "This Policy applies to information we collect through:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "the Paperzilla.ai website and Service,"
            }
          ],
          [
            {
              "text": "communications with us (e.g., support emails),"
            }
          ],
          [
            {
              "text": "product analytics and cookies (as described below)."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "This Policy does not apply to third-party websites or services that we do not control, even if the Service links to them."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "3. Information We Collect"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "3.1 Information you provide"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We may collect:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Account information:",
              "bold": true
            },
            {
              "text": " email address, authentication information, and account settings."
            }
          ],
          [
            {
              "text": "Research interests and preferences:",
              "bold": true
            },
            {
              "text": " the topics, keywords, fields, authors, sources, and filters you configure to personalize your feed."
            }
          ],
          [
            {
              "text": "Communications:",
              "bold": true
            },
            {
              "text": " information you send us (e.g., support requests)."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "3.2 Information we collect automatically"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "When you use the Service, we may automatically collect:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Usage data:",
              "bold": true
            },
            {
              "text": " pages viewed, features used, clicks, searches, and interactions with the feed."
            }
          ],
          [
            {
              "text": "Device and log data:",
              "bold": true
            },
            {
              "text": " IP address, browser type, device type, operating system, timestamps, and diagnostic logs."
            }
          ],
          [
            {
              "text": "Approximate location:",
              "bold": true
            },
            {
              "text": " inferred from IP address (typically city/country level)."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "3.3 Research publication metadata"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "As part of the Service, we process information about research publications, which may include:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "paper titles, abstracts, keywords, publication dates, journal/conference names,"
            }
          ],
          [
            {
              "text": "author names and affiliations (as provided by the source),"
            }
          ],
          [
            {
              "text": "links/identifiers (e.g., DOI or other identifiers, where available)."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "This information is typically collected from publicly available sources or licensed feeds and is used to power discovery and filtering."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "3.4 Payment information"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "If you purchase a paid plan, payments are processed by Stripe. We receive limited billing information from Stripe (such as subscription status, invoice history, and payment confirmations). We do not store full payment card numbers."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "4. How We Use Information"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We use information to:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Provide and operate the Service:",
              "bold": true
            },
            {
              "text": " create accounts, authenticate users, personalize feeds based on research interests, and deliver features."
            }
          ],
          [
            {
              "text": "Improve and maintain the Service:",
              "bold": true
            },
            {
              "text": " understand performance, fix bugs, and improve ranking/quality."
            }
          ],
          [
            {
              "text": "Analytics:",
              "bold": true
            },
            {
              "text": " measure usage and quality signals to improve relevance and user experience."
            }
          ],
          [
            {
              "text": "Derived improvement data:",
              "bold": true
            },
            {
              "text": " create and use aggregated, de-identified, or anonymized data derived from usage signals, including paper upvotes and downvotes, to evaluate and improve retrieval, ranking, recommendations, and overall Service quality."
            }
          ],
          [
            {
              "text": "Security and abuse prevention:",
              "bold": true
            },
            {
              "text": " protect accounts, prevent fraud, and maintain Service integrity."
            }
          ],
          [
            {
              "text": "Billing and account administration:",
              "bold": true
            },
            {
              "text": " process subscriptions, invoices, and customer support."
            }
          ],
          [
            {
              "text": "Communications:",
              "bold": true
            },
            {
              "text": " send service-related messages (e.g., confirmations, notices, support replies). If we send marketing emails, you can opt out at any time."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "5. Legal Bases for Processing (EEA/UK/Switzerland)"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "If you are located in the EEA/UK/Switzerland, we process personal data under these legal bases:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Contract:",
              "bold": true
            },
            {
              "text": " to provide the Service you requested (e.g., account access, personalization)."
            }
          ],
          [
            {
              "text": "Legitimate interests:",
              "bold": true
            },
            {
              "text": " to secure, improve, and operate the Service, including analytics and quality measurement (balanced against your rights)."
            }
          ],
          [
            {
              "text": "Consent:",
              "bold": true
            },
            {
              "text": " for non-essential cookies where required (see Cookies section)."
            }
          ],
          [
            {
              "text": "Legal obligation:",
              "bold": true
            },
            {
              "text": " to comply with applicable laws, lawful requests, and recordkeeping requirements."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "6. AI / Automated Processing and Model Training"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla uses automated techniques to filter and enhance research information and personalize your feed."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "No user-content model training:",
            "bold": true
          },
          {
            "text": " We do not use your research interests/preferences or other account inputs to train third-party models, and we do not send your inputs to third-party model providers for processing as part of our recommendation service. If you choose to connect an AI client, that client can retrieve the data covered by the permissions you approve, as described below."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "No human review of your inputs:",
            "bold": true
          },
          {
            "text": " We do not routinely have humans review your research interests/preferences. We may access account information only as needed for support, security, or legal compliance."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "7. How We Share Information"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We may share personal information with:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Service providers (processors):",
              "bold": true
            },
            {
              "text": " companies that help us run the Service (e.g., cloud hosting, database providers, monitoring, email delivery, customer support tooling)."
            }
          ],
          [
            {
              "text": "Stripe:",
              "bold": true
            },
            {
              "text": " for payment processing and subscription management."
            }
          ],
          [
            {
              "text": "Analytics providers:",
              "bold": true
            },
            {
              "text": " including Umami (privacy-focused, cookieless analytics; see Cookies section)."
            }
          ],
          [
            {
              "text": "Legal and safety:",
              "bold": true
            },
            {
              "text": " if required by law or to protect rights, safety, and security."
            }
          ],
          [
            {
              "text": "Business transfers:",
              "bold": true
            },
            {
              "text": " if we are involved in a merger, acquisition, financing, reorganization, bankruptcy, or sale of assets."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "No advertising \"sale\" or \"sharing\":",
            "bold": true
          },
          {
            "text": " We do not sell personal information for money and we do not share personal information for cross-context behavioral advertising."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "Connected AI clients"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "When you connect an AI client through OAuth, you choose its permissions. Paperzilla shares the requested public research data and, if you grant project access, your project information and feeds with that client. The client’s own privacy policy governs its use of those results. We store the client identity, permissions, connection activity, and hashed credentials to operate and secure the connection. We do not share your Paperzilla sign-in session with the client. Revoke access in Connect AI clients; existing copies held by the client are subject to its retention policy."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "8. International Data Transfers"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla is based in the United States. If you access the Service from the EEA/UK or other regions, your information may be transferred to and processed in the United States and other countries where our service providers operate."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Where required, we use appropriate safeguards for international transfers, such as the European Commission's Standard Contractual Clauses (and the UK addendum where applicable), along with additional measures as appropriate."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "9. Data Retention"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We retain personal information for as long as necessary to:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "provide the Service,"
            }
          ],
          [
            {
              "text": "maintain legitimate business records (e.g., billing and compliance),"
            }
          ],
          [
            {
              "text": "resolve disputes,"
            }
          ],
          [
            {
              "text": "enforce agreements, and"
            }
          ],
          [
            {
              "text": "maintain security and prevent abuse."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "In general:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Account and preference data is retained while your account is active."
            }
          ],
          [
            {
              "text": "If you request deletion, we will take steps to delete or anonymize personal data within a reasonable period, subject to legal and operational requirements."
            }
          ],
          [
            {
              "text": "Residual copies may remain in backups for a limited time."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "10. Security"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We implement reasonable technical and organizational measures designed to protect personal information (e.g., access controls, encryption in transit, monitoring). No method of transmission or storage is completely secure, and we cannot guarantee absolute security."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "11. Your Rights and Choices"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "11.1 Email preferences"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "You can opt out of marketing emails using the unsubscribe link (if present) or by contacting hello@paperzilla.ai. Service/transactional emails (e.g., billing, account notices) may still be sent."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "11.2 GDPR/UK GDPR rights (EEA/UK users)"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Depending on your location, you may have rights to:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "access your personal data,"
            }
          ],
          [
            {
              "text": "correct inaccurate data,"
            }
          ],
          [
            {
              "text": "delete personal data,"
            }
          ],
          [
            {
              "text": "restrict or object to processing,"
            }
          ],
          [
            {
              "text": "data portability,"
            }
          ],
          [
            {
              "text": "withdraw consent (where processing is based on consent),"
            }
          ],
          [
            {
              "text": "lodge a complaint with a supervisory authority."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "To exercise these rights, contact hello@paperzilla.ai."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "11.3 U.S. state privacy rights"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Depending on your state, you may have rights to access, delete, and correct certain personal information, and to opt out of certain processing defined by law."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Because we do not sell personal information or share it for cross-context behavioral advertising, typical \"Do Not Sell/Share\" requests generally will not apply to our operations — but you can still contact us at hello@paperzilla.ai with any request."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "12. Cookies and Similar Technologies"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We use cookies and similar technologies (e.g., local storage and pixels/SDKs) for core functionality and analytics."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "12.1 Cookie categories"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Strictly necessary cookies:",
              "bold": true
            },
            {
              "text": " required for core site functionality, security, and session management."
            }
          ],
          [
            {
              "text": "Analytics cookies:",
              "bold": true
            },
            {
              "text": " help us understand how the Service is used and improve relevance and quality (e.g., in-house analytics)."
            }
          ],
          [
            {
              "text": "Functional cookies (if used):",
              "bold": true
            },
            {
              "text": " remember preferences (e.g., language or UI settings)."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We do not use advertising or retargeting pixels."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "12.2 Umami analytics"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We use Umami, a privacy-focused analytics tool, to measure site and product usage. Umami does not use cookies or collect personal data."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "12.3 In-house analytics"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We also use custom, in-house analytics focused on quality and relevance measurement. This may use first-party cookies or local storage to measure feature usage and improve the Service."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "12.4 Managing cookies"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "You can control cookies through:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "our cookie banner / consent manager (where required),"
            }
          ],
          [
            {
              "text": "your browser settings (block or delete cookies)."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Blocking some cookies may affect Service functionality."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "12.5 Do Not Track"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Some browsers send \"Do Not Track\" signals. Because there is no universally accepted standard, we do not respond to these signals in a uniform way."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "13. Children's Privacy"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "The Service is not intended for children, and we do not knowingly collect personal information from children under 13 (or under 16 in some jurisdictions). If you believe a child provided personal information, contact hello@paperzilla.ai."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "14. Changes to This Policy"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We may update this Policy from time to time. We will update the \"Last Updated\" date and, if changes are material, provide additional notice where required."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "15. Contact"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "For privacy questions or requests, contact: hello@paperzilla.ai"
          }
        ]
      }
    ],
    "contentLocale": "en"
  },
  "terms": {
    "id": "terms",
    "variant": "legal",
    "publicPath": "/terms",
    "metaTitle": "Terms & Conditions - Paperzilla",
    "metaDescription": "Terms & Conditions governing your use of Paperzilla.ai.",
    "pageTitle": "Terms & Conditions",
    "effectiveDate": "Effective Date: March 1, 2026 · Last Updated: March 31, 2026",
    "blocks": [
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "These Terms & Conditions (\"Terms\") govern your access to and use of Paperzilla.ai and any related websites, applications, tools, and services (collectively, the \"Service\"). The Service is operated by Paperzilla Inc., a Delaware corporation (\"Paperzilla,\" \"we,\" \"us,\" or \"our\")."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "By accessing or using the Service, you agree to these Terms. If you do not agree, do not use the Service."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "1. Company Information and Contact"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla Inc.\n131 Continental Dr Suite 305\nNewark, DE, 19713\nUnited States"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Email (support and legal notices): hello@paperzilla.ai"
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "2. Eligibility and Authority"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "You must be at least "
          },
          {
            "text": "18 years old",
            "bold": true
          },
          {
            "text": " (or the age of majority where you live) to use the Service."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "If you use the Service on behalf of a company, institution, or other entity, you represent and warrant that you have authority to bind that entity to these Terms, and \"you\" includes that entity."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "3. The Service"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla collects newly published research papers and filters and enhances them according to a user's stated research interests and preferences."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "The Service may include features that use statistical methods, machine learning, or other automated techniques to rank, summarize, tag, classify, or otherwise enhance research information. Outputs and rankings are not guaranteed to be correct or complete."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "4. Accounts and Security"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "You may need to create an account to access the Service. You agree to:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "provide accurate and current information,"
            }
          ],
          [
            {
              "text": "maintain the confidentiality of your login credentials,"
            }
          ],
          [
            {
              "text": "promptly notify us if you suspect unauthorized access to your account."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "You are responsible for activity that occurs under your account."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "5. User Inputs and Your Responsibilities"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "5.1 What you provide"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Currently, Paperzilla does "
          },
          {
            "text": "not",
            "bold": true
          },
          {
            "text": " require you to upload documents. You may provide:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "account information (like email),"
            }
          ],
          [
            {
              "text": "research interests and preferences, and"
            }
          ],
          [
            {
              "text": "feedback or support requests."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "5.2 Your responsibilities"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "You agree that you will not provide information you do not have the right to provide, and you will comply with applicable laws when using the Service."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "6. Research Content and Third-Party Materials"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "6.1 Third-party ownership"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Research papers, abstracts, figures, and other publication materials (\"Research Content\") are generally owned by their respective authors, publishers, or rights holders. Paperzilla is not affiliated with those rights holders unless explicitly stated."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "6.2 Links and access"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "The Service may link to third-party sites or sources. Your access to, or use of, third-party materials is governed by the applicable third party's terms, licenses, and policies. Paperzilla is not responsible for third-party content, sites, or availability."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "6.3 No guarantee of completeness"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paper coverage, freshness, and metadata completeness can vary by source. We do not guarantee that the Service includes all publications or that any publication will appear in your feed."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "7. Acceptable Use"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "You agree not to:"
          }
        ]
      },
      {
        "type": "ordered-list",
        "items": [
          [
            {
              "text": "Use the Service in violation of any law or regulation."
            }
          ],
          [
            {
              "text": "Interfere with or disrupt the Service (including probing, scanning, or testing vulnerabilities without permission)."
            }
          ],
          [
            {
              "text": "Upload or transmit malware or harmful code."
            }
          ],
          [
            {
              "text": "Attempt to access another user's account or non-public areas of the Service."
            }
          ],
          [
            {
              "text": "Reverse engineer, decompile, or attempt to discover source code or underlying systems except to the extent such restriction is prohibited by law."
            }
          ],
          [
            {
              "text": "Use any automated means to access the Service or collect content from it (including scraping, crawling, or harvesting) except as explicitly allowed by Paperzilla in writing."
            }
          ],
          [
            {
              "text": "Circumvent or attempt to circumvent rate limits, access controls, or restrictions."
            }
          ],
          [
            {
              "text": "Use the Service to create a competing database by systematically extracting or copying Service outputs at scale."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We may suspend or terminate your access if we reasonably believe you violated these Terms."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "8. Plans, Billing, Trials, and Refunds"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "8.1 Paid plans and subscription fees"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla offers paid plans with recurring subscription fees shown in the product or order flow."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Pricing and plan details are shown at checkout, within the Service, or in an order form."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "8.2 Payment processor"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Payments are processed via Stripe. By purchasing a paid plan, you authorize Paperzilla and Stripe to charge your payment method for applicable fees, taxes, and charges."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "8.3 Free trial and auto-conversion"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "If you start a 14-day free trial, your trial will automatically convert to a paid subscription at the end of the trial period unless you cancel before the trial ends. If you do not want to be charged, you must cancel before the trial ends."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "8.4 Renewal and cancellation"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Subscriptions renew automatically until canceled. You can cancel through the Service (if available) or by contacting hello@paperzilla.ai. Unless otherwise stated, cancellation stops renewal; it does not retroactively refund fees already paid (subject to the refund policy below and any rights required by law)."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "8.5 Refund policy (7 days)"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "If you are charged for a new paid subscription, you may request a refund of the subscription fee within 7 days of the initial charge by emailing hello@paperzilla.ai from the account email address."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Refunds may be denied in cases of fraud, abuse, or violation of these Terms."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "9. Intellectual Property"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "9.1 Our IP"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "The Service, including its software, design, branding, and all related intellectual property rights, is owned by Paperzilla or its licensors and is protected by applicable laws."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "9.2 Limited license to you"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Subject to these Terms, Paperzilla grants you a limited, non-exclusive, non-transferable, revocable license to access and use the Service for your internal business or personal research purposes."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "9.3 Feedback"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "If you provide feedback, ideas, or suggestions, you grant Paperzilla a perpetual, irrevocable, worldwide, royalty-free license to use them without restriction or compensation."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "10. Privacy"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Our Privacy & Cookie Policy explains how we collect, use, and share personal information. By using the Service, you acknowledge our privacy practices."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We may create and use aggregated, de-identified, or anonymized data derived from your use of the Service, including interaction signals such as paper upvotes and downvotes, to evaluate, improve, and develop the Service, including retrieval, ranking, and recommendation quality."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "11. Suspension and Termination"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "You may stop using the Service at any time. We may suspend or terminate your access:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "if you violate these Terms,"
            }
          ],
          [
            {
              "text": "if your use creates risk or harm to the Service, other users, or Paperzilla,"
            }
          ],
          [
            {
              "text": "if required to comply with law,"
            }
          ],
          [
            {
              "text": "for non-payment (for paid accounts)."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Upon termination, your right to use the Service stops immediately."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "12. Disclaimers"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "THE SERVICE IS PROVIDED \"AS IS\" AND \"AS AVAILABLE.\" TO THE MAXIMUM EXTENT PERMITTED BY LAW, PAPERZILLA DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla does not guarantee that:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "the Service will be uninterrupted or error-free,"
            }
          ],
          [
            {
              "text": "any ranking, summary, recommendation, or enhancement is accurate or complete,"
            }
          ],
          [
            {
              "text": "the Service will meet your requirements."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "You are responsible for how you use information provided by the Service."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "13. Limitation of Liability"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "TO THE MAXIMUM EXTENT PERMITTED BY LAW:"
          }
        ]
      },
      {
        "type": "plain-list",
        "items": [
          [
            {
              "text": "PAPERZILLA WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR FOR LOST PROFITS, LOST REVENUES, LOSS OF DATA, OR LOSS OF GOODWILL."
            }
          ],
          [
            {
              "text": "PAPERZILLA'S TOTAL LIABILITY FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THE SERVICE WILL NOT EXCEED THE AMOUNT YOU PAID TO PAPERZILLA FOR THE SERVICE IN THE 12 MONTHS BEFORE THE EVENT GIVING RISE TO LIABILITY, OR $100, WHICHEVER IS GREATER."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Some jurisdictions do not allow certain limitations of liability; in such jurisdictions, liability will be limited to the fullest extent permitted by law."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "14. Indemnification"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "You agree to defend, indemnify, and hold harmless Paperzilla and its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses (including reasonable attorneys' fees) arising from:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "your use of the Service,"
            }
          ],
          [
            {
              "text": "your violation of these Terms,"
            }
          ],
          [
            {
              "text": "your violation of any law or third-party right."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "15. Governing Law and Venue"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "These Terms are governed by the laws of the State of Delaware, excluding its conflict-of-law rules."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Any dispute, claim, or controversy arising out of or relating to these Terms or the Service will be brought exclusively in the state or federal courts located in Delaware, and you consent to personal jurisdiction and venue there."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "16. Changes to These Terms"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "We may update these Terms from time to time. If we make material changes, we will provide notice by posting updated Terms on the Site and updating the \"Last Updated\" date (and, where appropriate, by email or in-product notice). Your continued use of the Service after the effective date of changes constitutes acceptance of the updated Terms."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "17. Miscellaneous"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Severability:",
              "bold": true
            },
            {
              "text": " If any provision is found unenforceable, the remaining provisions remain in effect."
            }
          ],
          [
            {
              "text": "Assignment:",
              "bold": true
            },
            {
              "text": " You may not assign these Terms without our prior written consent. We may assign these Terms in connection with a merger, acquisition, or sale of assets."
            }
          ],
          [
            {
              "text": "Entire Agreement:",
              "bold": true
            },
            {
              "text": " These Terms and the Privacy & Cookie Policy are the entire agreement between you and Paperzilla about the Service."
            }
          ],
          [
            {
              "text": "Export Controls:",
              "bold": true
            },
            {
              "text": " You agree to comply with applicable export control and sanctions laws when using the Service."
            }
          ]
        ]
      }
    ],
    "contentLocale": "en"
  }
}
